import React, {useState, useEffect, useContext} from 'react'
import SearchLayout from '../components/search-layout'
import Result from '../components/result'
import {AppContext} from '../context/context'
import i18n from '../utils/i18n'
import {getELawsDescriptions} from '../utils/elawsDescription'

const SearchResultsPage = () => {
  const {state} = useContext(AppContext)
  const [elawsDescriptions, setElawsDescriptions] = useState()

  i18n.changeLanguage(state.language)
  const cookieLanguage = document?.cookie
    ?.split('; ')
    ?.find(row => row.startsWith('lang='))
    ?.split('=')[1]

  // Set cookie on language change to be persistant with ontario.ca
  if (cookieLanguage !== state.language) {
    const expirationDate = new Date()
    expirationDate.setDate(new Date().getDate() + 400)
    document.cookie = `lang=${
      state.language
    }; expires=${expirationDate.toUTCString()}; path=/`
  }

  useEffect(() => {
    // Do the fetch request for elaws descriptions when the query and/or filter changes
    if (state.filter === 'elaws') {
      // Since the API request is asyncronous, we need to wait for the response first.
      getELawsDescriptions(state.query, state.language).then(response =>
        setElawsDescriptions(response),
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.filter])

  const resultView = (results, index) => (
    <Result
      searchRecord={results}
      query={state.query}
      resultPos={index}
      elawsDescriptionsObject={elawsDescriptions}
    />
  )

  return (
    <SearchLayout
      isSearchResultsPage={true}
      language={state.language}
      generateResultView={resultView}
    />
  )
}

export default SearchResultsPage
